import {
    Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, Output, EventEmitter,
    ComponentFactoryResolver, ViewContainerRef
} from "@angular/core";
import { ResearchPopupComponent } from './research-popup';
import { ResearchCardEditComponent } from './research-card-edit';
import { ResearchCard, CannabisOption, SharedComponent, PartnerNamesEnum } from '../shared';
import { SharedService } from '../../shared'
declare var jsPanel: any;

@Component({
    selector: 'app-literature-research',
    templateUrl: "./literature-research.component.html",
    styleUrls: ["./literature-research.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class LiteratureResearchComponent implements OnInit {
    @Input() partnerName: string = "";
    @Input() researchCards: ResearchCard[] = [];
    @Input() suggestedOptions: CannabisOption[] = [];
    @Output() updatedCards: any = new EventEmitter();


    PartnerNamesEnum = PartnerNamesEnum;

    jsPanelGrid: any;
    jsPanelEdit: any;

    get panelWidth() {
        return Math.min(1400, window.innerWidth * 0.9);
    }

    get panelHeight() {
        return Math.min(1100, window.innerHeight * 0.9);
    }

    get jsPanelContentHeight() {
        return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
    }

    get gridBodyHeight() {
        return this.jsPanelContentHeight - 135;
    }

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    constructor(private cd: ChangeDetectorRef,
        private vcr: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {

    }

    openResearchPopup() {
        if (this.sharedService.isAntragPatient()) {
            const factory = this.resolver.resolveComponentFactory(SharedComponent);
            const componentRef = this.vcr.createComponent(factory);
            componentRef.instance.showPopupForLogin(this.partnerName);
            return;
        }
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(ResearchPopupComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        componentRef.instance.researchCards = [...this.researchCards];
        componentRef.instance.suggestedOptions = [...this.suggestedOptions];
        componentRef.instance.updateJsPanelTitle.subscribe(title => {
            if (this.jsPanelGrid) {
                this.jsPanelGrid.setHeaderTitle(title);
            }
        })

        const element = componentRef.location.nativeElement;

        let component = this;
        this.jsPanelGrid = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Literature Research',
            onwindowresize: true,
            content: element,
            onstatuschange: (panel, status) => {
                componentRef.instance.fnUpdateResearchGrid();
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                    componentRef.instance.fnUpdateResearchGrid();
                }
            },
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                component.researchCards = componentRef.instance.researchCards;
                                component.updatedCards.emit(component.researchCards);
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelGrid = this.sharedService.setJsPanelProperty(this.jsPanelGrid, this.partnerName);
    }

    editCard(card) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(ResearchCardEditComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.card = { ...card };
        const element = componentRef.location.nativeElement;

        let component = this;
        this.jsPanelEdit = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Edit detail',
            onwindowresize: true,
            content: element,
            onstatuschange: (panel, status) => {
                componentRef.instance.fnUpdateEditorHeight();
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                    componentRef.instance.fnUpdateEditorHeight();
                }
            },
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                let index = component.researchCards.findIndex(a => a.id == card.id);
                                if (index > -1) {
                                    const abstract = componentRef.instance.summaryEditor.getHTML();
                                    component.researchCards[index] = { ...componentRef.instance.card, abstract: abstract };
                                }
                                component.updatedCards.emit(component.researchCards);
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelEdit = this.sharedService.setJsPanelProperty(this.jsPanelEdit, this.partnerName);
    }

    removeCard(index) {
        this.researchCards.splice(index, 1);
        this.updatedCards.emit(this.researchCards);
    }

    onCardAction(event) {
        switch (event.TYPE) {
            case 'EDIT':
                this.editCard(event.VALUE);
                break;
            case 'DELETE':
                this.removeCard(event.VALUE);
                break;
            default:
                break;
        }
    }
}
